class PageAttributes {
   privateLabelId: number;
   attributes: Array<Attributes>;
}

class Attributes {
  type?: Type;
  attributes?: any;
}
class Type {
  id: number;
  name: string;
  keys?: any;
}

enum PageAttributeType {
  CSS_ATTRIBUTE_TYPE = 1,
  CSS_IMAGE_TYPE = 2,
  PAGE_ATTRIBUTE_TYPE = 3,
  PAGE_IMAGE_TYPE = 4,
  PAGE_PDF_TYPE = 5,
  HOME_PAGE_QUICK_LINKS_TYPE = 6,
  PAGE_ELEMENT_SECTION_CONFIG_TYPE = 8,
  PAGE_TEMPLATE = 10,
  ELEMENT_LIST = 13,
  CONTACT_US_INFO = 14,
  FOOTER_INFO = 15,
  VUE_PAGE_CONFIGURATIONS = 20,
  WIDGET_PAGE_TEMPLATE = 30,
  MISC_SITE_CONFIG = 32,
}

const PageAttributeTypeArray: Array<number> = [
  1, 2, 3, 4, 5, 6, 8, 10, 14, 15, 20, PageAttributeType.ELEMENT_LIST, PageAttributeType.MISC_SITE_CONFIG,
];


export {
  PageAttributes,
  Attributes,
  Type,
  PageAttributeType,
  PageAttributeTypeArray,
};
